import { API_LOADING, ERROR_DISPLAY } from "../actionTypes";

export const setAPILoader = (value) => {
  return {
    type: API_LOADING,
    payload: value,
  };
};

export const setErrorDisplay = (value) => {
  return {
    type: ERROR_DISPLAY,
    payload: value,
  };
};
